import G6, { TreeGraph } from '@antv/g6/dist/g6.min';
import { directSubRuleOperationOptions } from '../options';
import { generateActionBar } from './common';
import {
  conditionContentPaddingY,
  conditionRowHeight,
  conditionRowInnerHeight,
  conditionTitleHeight,
  CustomNodeType,
  splitLineHeight,
  splitLineMargin,
  textareaHeight
} from './config';

function changeEvtfn(e) {
  const target = e.target;
  // 活动类型
  if (target.classList.contains('simple-condition-select')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onSimpleConditionChange(id, e.target);
  }
}

export const registerSimpleConditionShape = (rowData) => {
  G6.registerNode(CustomNodeType.SIMPLE_CONDITION, {
    draw: (cfg, group) => {
      const jsonData = rowData[cfg.dataId];

      const conditionHtml = `
      <div style="display: flex;align-items: center;column-gap: 4px;height: ${conditionRowHeight}px">
        <select data-id="${
          cfg!.id
        }" class="simple-condition-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="类型">
          ${directSubRuleOperationOptions.reduce(
            (t, c) =>
              t +
              `<option value="${c.value}" ${
                c.value === jsonData.equityInformationRule.directDescentOption ? 'selected' : ''
              }>${c.label}</option>`,
            ''
          )}
        </select>
      </div>
    `;

      // 只监听一次事件
      document.body.removeEventListener('change', changeEvtfn);
      document.body.addEventListener('change', changeEvtfn);

      return group!.addShape('dom', {
        attrs: {
          width: cfg!.size![0],
          height: cfg!.size![1],
          // 传入 DOM 的 html
          html: `
          <div>
            <div style="background-color: #f2f2f2;border-radius:4px;height: 100%;">
              <div style="background-color: ${
                cfg!.style!.titleBgColor
              }; color: #fff; font-size: 12px;text-align: center;border-radius:4px;height: ${conditionTitleHeight}px;line-height: ${conditionTitleHeight}px;">
              ${cfg!.title}
              </div>
              <div style="padding: ${conditionContentPaddingY}px ${conditionContentPaddingY * 2}px;">
                <div style="display: flex;">
                  ${conditionHtml}
                </div>
                <div style="height: ${splitLineHeight}px;margin: ${splitLineMargin}px 0;background-color: ${
            cfg!.isPre ? '#d70a25' : 'var(--oio-button-primary-background)'
          };">
                </div>
                <textarea 
                  class="activity-textarea"
                  data-id="${cfg!.id}"
                  placeholder="${cfg!.isPre ? '请输入必定提示文案' : '请输入活动提示文案'}" 
                  style="width: 100%;height: ${textareaHeight}px;border-radius: 4px;padding: 3px;resize: none;" 
                  rows="3">${jsonData.effectConditionDesc}</textarea>
              </div>
            </div>
            ${generateActionBar({ ...jsonData, ...cfg })}
          </div>
        `
        }
      });
    }
  });
};
